import { Container, Row, Col } from "react-bootstrap";
import { Outlet } from "react-router-dom";

function SetupLayout() {
  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <div className="text-center mb-4">
            <h1>Podium Setup</h1>
            <p className="text-muted">Let's get your league set up</p>
          </div>
          <Outlet />
        </Col>
      </Row>
    </Container>
  );
}

export default SetupLayout;
